import { render, staticRenderFns } from "./Polaroid.vue?vue&type=template&id=e2795646&scoped=true&"
import script from "./Polaroid.vue?vue&type=script&lang=js&"
export * from "./Polaroid.vue?vue&type=script&lang=js&"
import style0 from "./Polaroid.vue?vue&type=style&index=0&id=e2795646&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2795646",
  null
  
)

export default component.exports